import React from 'react';
import SVGLoader from './SVGLoader';

const defaults = {
  width: 17,
  height: 16,
  viewboxWidth: 17,
  viewboxHeight: 16,
};

const EMSIcon = ({
  width = defaults.width,
  height = defaults.height,
  viewboxWidth = defaults.viewboxWidth,
  viewboxHeight = defaults.viewboxHeight,
  ...rest
}) => {
  return (
    <SVGLoader
      width={width}
      height={height}
      viewboxWidth={viewboxWidth}
      viewboxHeight={viewboxHeight}
      {...rest}
    >
      <g>
        <path
          d="M16.832 9.778a.889.889 0 0 1-.89.889h-3.555a.889.889 0 0 0-.889.889v3.555a.889.889 0 0 1-.888.889H7.054a.889.889 0 0 1-.889-.889v-3.555a.889.889 0 0 0-.889-.89H1.721a.889.889 0 0 1-.89-.888V6.222a.889.889 0 0 1 .89-.889h3.555a.889.889 0 0 0 .89-.889V.89A.889.889 0 0 1 7.053 0h3.556a.889.889 0 0 1 .889.889v3.555a.889.889 0 0 0 .888.89h3.556a.889.889 0 0 1 .889.888v3.556Z"
          fill="currentColor"
        />
      </g>
    </SVGLoader>
  );
};

export default EMSIcon;
